import { useState } from 'react'
import Card from '@mui/joy/Card'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Textarea from '@mui/joy/Textarea'
import Input from '@mui/joy/Input'
import Button from '@mui/joy/Button'

export const ListingCampaignForm = ({ onSubmit }) => {
    const [url, setUrl] = useState(null)
    const [title, setTitle] = useState(null)

    return (
        <Card
            sx={{
                width: 450,
                maxWidth: 900,
            }}
            variant="outlined"
            color="neutral"
        >
            <FormControl sx={{ display: 'flex', gap: 2 }}>
                <div>
                    <FormLabel>Campaign Title</FormLabel>
                    <Input
                        placeholder="My Campaign"
                        required
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div>
                    <FormLabel>Property Listing Url</FormLabel>
                    <Input
                        placeholder="www.myRealEstateSite.com/listing"
                        required
                        onChange={(e) => setUrl(e.target.value)}
                    />
                </div>
                <Button
                    variant="solid"
                    color="primary"
                    type="submit"
                    disabled={!url || !title}
                    sx={{ minWidth: 100, alignSelf: 'end' }}
                    onClick={() => onSubmit({ title: title, url: url })}
                >
                    Go
                </Button>
            </FormControl>
        </Card>
    )
}
